export default __webpack_public_path__ + "e16c967c59524f705cdca9e19366e6eb.png";